module.exports = __webpack_public_path__ + "static/img/logo.22e5e447.png";